module.exports = __webpack_public_path__ + "fonts/Poppins-BoldItalic.09775bde.ttf";